import { useEffect } from "react";

function Chatbot() {
   useEffect(() => {
    // Prevent duplicate script
    if (document.getElementById("jotform-chatbot")) return;

    const script = document.createElement("script");

    script.id = "jotform-chatbot";

    script.src =
      "https://cdn.jotfor.ms/agent/embedjs/019e49ff997c7cc4a5e8427dbc248953c442/embed.js";

    script.async = true;

    script.onerror = () => {
      console.log("Jotform chatbot failed to load");
    };

    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById("jotform-chatbot");

      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return null;
};

export default Chatbot;